import React from "react";
import AppComponent from "../../../Components/AppComponent";
import _ from "lodash";

import UnpActions from "../../../Stores/redux/UnPersist/Actions";
import PActions from "../../../Stores/redux/Persist/Actions";
import { connect } from "react-redux";
import AppModal from "../../../Components/Models/app-modal";
import {
  Form,
  Button,
  InputGroup,
  FormControl,
  Row,
  Col,
} from "react-bootstrap";
import api from "../../../Services/Api/api";

const SCREEN_NAME = "EDIT_AGENT_SCREEN";

// Utility to generate random username/password
const generateRandomCredentials = () => {
  const timestamp = Date.now().toString().slice(-6);
  const random4 = Math.floor(1000 + Math.random() * 9000);
  const username = `agent_${timestamp}_${random4}`;
  const password = Math.random().toString(36).slice(-8);
  return { username, password };
};

class EditAgentInner extends AppComponent {
  state = {
    firstName: this.props.agent?.firstName || "",
    lastName: this.props.agent?.lastName || "",
    countryCode: this.props.agent?.countryCode || "91",
    phone: this.props.agent?.phone || "",
    email: this.props.agent?.email || "",
    address: this.props.agent?.address || "",
    agentRatesPickup: this.props.agent?.agent?.rates?.pickup || "",
    agentRatesDelivery: this.props.agent?.agent?.rates?.delivery || "",
    workingArea: this.props.agent?.agent?.workingArea || "",
    isActive: this.props.agent?.agent?.isActive ?? true,
    status: this.props.agent?._id ? this.props.agent?.status : "active",
    loading: false,
    error: null,
  };

  formRef = React.createRef(null);

  async onSubmit() {
    try {
      if (this.state.loading) return;
      const isValid = this.formRef?.current?.reportValidity();
      if (!isValid) return;

      this.setAsyncState({ loading: true, error: null });

      const isEditing = !!this.props.agent?._id;
      let payload = {
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        phone: this.state.phone,
        email: this.state.email,
        address: this.state.address,
        countryCode: this.state.countryCode,
        status: this.state.status,
        role: "agent",
        agent: {
          rates: {
            pickup: parseFloat(this.state.agentRatesPickup) || 0,
            delivery: parseFloat(this.state.agentRatesDelivery) || 0,
          },
          workingArea: this.state.workingArea,
          isActive: !!this.state.isActive,
        },
      };

      if (!isEditing) {
        // Generate random username and password
        const { username, password } = generateRandomCredentials();
        payload.username = username;
        payload.password = password;
      }

      let res;
      if (isEditing) {
        res = await api.patch(
          `v1/office/user/${this.props.agent._id}`,
          _.pick(payload, [
            "firstName",
            "lastName",
            "phone",
            "email",
            "address",
            "countryCode",
            "status",
            "agent",
          ])
        );
      } else {
        res = await api.post("v1/office/user", payload);
      }

      this.setAsyncState({ loading: false });
      this.props.onSubmit(res);
    } catch (e) {
      this.setAsyncState({ error: e.message, loading: false });
    }
  }

  renderForm() {
    const {
      firstName,
      lastName,
      countryCode,
      phone,
      email,
      address,
      agentRatesPickup,
      agentRatesDelivery,
      workingArea,
      isActive,
      status,
      error,
    } = this.state;

    return (
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          this.onSubmit();
        }}
        ref={this.formRef}
      >
        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>First Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="First Name"
                value={firstName}
                onChange={(e) =>
                  this.setAsyncState({ firstName: e.target.value })
                }
                required
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Last Name"
                value={lastName}
                onChange={(e) =>
                  this.setAsyncState({ lastName: e.target.value })
                }
              />
            </Form.Group>
          </Col>
        </Row>

        <Form.Group className="mb-3">
          <Form.Label>Phone Number</Form.Label>
          <InputGroup>
            <FormControl
              type="text"
              placeholder="Country Code"
              style={{ maxWidth: "7rem" }}
              value={countryCode}
              onChange={(e) =>
                this.setAsyncState({ countryCode: e.target.value })
              }
            />
            <FormControl
              type="number"
              placeholder="Phone Number"
              value={phone}
              onChange={(e) => this.setAsyncState({ phone: e.target.value })}
              required
            />
          </InputGroup>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => this.setAsyncState({ email: e.target.value })}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Address</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            placeholder="Address"
            value={address}
            onChange={(e) => this.setAsyncState({ address: e.target.value })}
          />
        </Form.Group>

        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Pickup Rate</Form.Label>
              <Form.Control
                type="number"
                placeholder="Pickup Rate"
                value={agentRatesPickup}
                onChange={(e) =>
                  this.setAsyncState({ agentRatesPickup: e.target.value })
                }
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Delivery Rate</Form.Label>
              <Form.Control
                type="number"
                placeholder="Delivery Rate"
                value={agentRatesDelivery}
                onChange={(e) =>
                  this.setAsyncState({ agentRatesDelivery: e.target.value })
                }
              />
            </Form.Group>
          </Col>
        </Row>

        <Form.Group className="mb-3">
          <Form.Label>Working Area</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter working area / PIN code"
            value={workingArea}
            onChange={(e) =>
              this.setAsyncState({ workingArea: e.target.value })
            }
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Field Executive Status</Form.Label>
          <Form.Select
            value={isActive ? "true" : "false"}
            onChange={(e) =>
              this.setAsyncState({ isActive: e.target.value === "true" })
            }
          >
            <option value="true">Active</option>
            <option value="false">Inactive</option>
          </Form.Select>
        </Form.Group>

        {error && <div className="text-danger small mb-2">{error}</div>}

        {!this.props.renderModal && (
          <Button variant="primary" type="submit">
            Submit
          </Button>
        )}
      </Form>
    );
  }

  renderModal() {
    const isEditing = !!this.props.agent?._id;
    return (
      <AppModal
        visible={this.props.visible}
        handleClose={this.props.handleClose}
        title={isEditing ? "Edit Field Executive" : "Add New Field Executive"}
        onSubmit={this.onSubmit.bind(this)}
        disableSubmit={this.state.loading}
        modalProps={{ centered: true }}
      >
        {this.renderForm()}
      </AppModal>
    );
  }

  render() {
    return this.props.renderModal ? this.renderModal() : this.renderForm();
  }
}

const mapDispatchToProps = (dispatch) => ({
  setScreenState: (obj, persist = false, screenName = SCREEN_NAME) =>
    persist
      ? dispatch(PActions.setPScreenState(screenName, obj))
      : dispatch(UnpActions.setVScreenState(screenName, obj)),
});

export default connect(null, mapDispatchToProps)(EditAgentInner);
